import { styled } from '@mui/material'

export const Root = styled('div')`
  margin: ${props => props.margin};
  width: 100%;
`
